import 'babel-polyfill';
import loadModules from '@pod-point/module-loader';
import combineDomModules from '@pod-point/dom-module-loader';
import * as dom from '@pod-point/dom-ops';
import { toggleElement, typeahead } from '@pod-point/pod-point-ui-toolkit';
import cookieNotice from '@pod-point/cookie-notice.js';
import './modules/installations-import';
import './modules/login-form';
import './modules/search';
import './modules/submission-figure-ajax';
import './modules/submission-figures';
import './modules/tags';
import './modules/dynamic-table';
import jsLang from './lib/jslang';

dom.whenReady(() => {
    loadModules({
        domModules: combineDomModules({
            toggleElement,
            typeahead,
        }),
    });

    cookieNotice.init(jsLang.get('common.cookieButtonText'), jsLang.get('common.cookieNoticeText'));

    Array.from(document.getElementsByClassName('btn--disabled-on-submit')).forEach(button => {
        button.addEventListener('click', e => {
            e.currentTarget.disabled = true;
            e.currentTarget.form.submit();
        });
    });
});
